import { useCallback, useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { getCurrentDate, getNextDate, getSubmit, isEmpty, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "../@constants"
import { userData, nextCheck } from "../@signals"


export default function useUserApp(needCheck=false) {
	const checkingLogging = useSignal(false)
	const isLogged = useSignal(nextCheck.value && nextCheck.value >= getCurrentDate().getTime())
	const isLoadingLogin = useSignal(false)
	const error = useSignal(null)
	const noDipiAccess = useSignal(false)

	const setUserData = newData => batch(() => {
		userData.value = newData
		nextCheck.value = getNextDate({ hours: 1 }).getTime()
		isLogged.value = true
	})

	useEffect(() => batch(() => {
		if (!isLogged.value && needCheck) {
			checkingLogging.value = true
			getSubmit(`${BACKEND_APIS.SESSION}/check-login`)
				.then(res => setUserData(res))
				.catch(() => batch(() => {
					if (!isEmpty(userData.value))
						userData.value = {}
				})).finally(() => checkingLogging.value = false)
		}
	}), [])

	const handleLogin = useCallback((username, password) => batch ( () => {
		isLoadingLogin.value = true
		postSubmit(`${BACKEND_APIS.SESSION}/login`, {
			username, password
		}).then(res => {
			if (res.error)
				error.value = "Invalid username or password entered."
			else if (res.noDipiAccess)
				noDipiAccess.value = true
			else {
				if (error.value)
					error.value = null
				setUserData(res)
			}
		}).catch(() => {
			if (nextCheck.value)
				nextCheck.value = null
			error.value = 'Server call failed. Please try again.'
		}).finally(() => isLoadingLogin.value = false)
	}), [])

	const handleLogout = useCallback(() => batch(() => {
		getSubmit(`${BACKEND_APIS.SESSION}/logout`).then(() => {
			if (!isEmpty(userData.value))
				userData.value = {}
			if (nextCheck.value)
				nextCheck.value = null
			isLogged.value = false
		})
	}), [])

	return {
		checkingLogging: checkingLogging.value,
		isLogged: isLogged.value,
		isLoadingLogin: isLoadingLogin.value,
		error: error.value,
		noDipiAccess: noDipiAccess.value,

		username: userData.value.username,
		userAccess: userData.value.access || [],
		userDashboardAccess: userData.value.dashboardAccess || userData.value.dashboardsAccess || userData.value.allowedDashboardKeys || [],
		modules: userData.value.modules || [],
		modulesConfig: userData.value.modulesConfig || userData.value.modulesConfig || {},
		userRole: userData.value.role || 'user',
		mainSite: userData.value.mainSite,
		singleCountryUser: userData.value.singleCountryUser,
		userCustomer: userData.value.customerID,
		userEmail: userData.value.email,
		userGroupByProductID: userData.value.groupByProductID,
		userUseRRSP : userData.value.useRRSP != null ? userData.value.useRRSP : 1,
		clickAndCollect: !!userData.value.clickAndCollect,

		handleLogin, handleLogout
	}
}